import React from 'react'
import PurpleBubbleContent from '../../../components/PurpleBubbleContent'

interface ContentItem {
  text?: string
}

interface PurpleBubbleDisplayProps {
  purpleBubbleContent: ContentItem | undefined
}

const PurpleBubbleDisplay: React.FC<PurpleBubbleDisplayProps> = ({
  purpleBubbleContent,
}) => {
  if (!purpleBubbleContent?.text) {
    return null
  }

  return <PurpleBubbleContent text={purpleBubbleContent.text} />
}

export default PurpleBubbleDisplay
